/*
 * html解析用mixin
 */
<script>
export default {
	methods: {
		/*
		 * htmlエンティティ処理
		 */
		htmlEntities: function ( str, proc ) {
		  if ( 'encode' === proc ) {
		    str = $('<div/>').text( str ).html();
		    return str.replace( '\'', '&apos;' ).replace( '"', '&quot;' );
		  } else {
		    return $("<div/>").html( str ).text();
		  }
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/HtmlAnalyze.mixin.vue